<template>
  <div class="s-diseases-container container">
    <topNav></topNav>
    <div class="s-diseases-top s-diseases-margin">
      <div class="section w1300 marginAuto">
        <div class="crumbs">
          <img src="../assets/image/index/home.png" class="img" alt />
          <span @click="goRoute('diseasesInsectPests')" class="go">病虫害&gt;</span>
          <span>病虫害详情</span>
        </div>
        <div class="detail-title">{{detialData.title}}</div>
        <div class="detail-img-wrap">
          <div class="detial-section-img" v-for="(item,index) in detialData.img" :key="index">
            <img :src="diseasesInsectPestsImgURL+item" alt="图片" class="bankLogo" />
          </div>
        </div>

        <div class="detail-diseaseDescribe">
          <p class="detail-diseaseDescribe-name">发病详情：</p>
          <p>{{detialData.diseaseDescribe}}</p>
        </div>
        <div class="detail-diseaseDescribe">
          <p class="detail-diseaseDescribe-name">防治方法：</p>
          <p>{{detialData.preventionPlan}}</p>
        </div>
        <div class="middle_honor">
          <p class="detail-diseaseDescribe-name">相似病例：</p>
          <div class="mid_content">
            <el-carousel class="s-honor-wrap" v-show="honorList[0].length>0">
              <el-carousel-item v-for="ele in honorNum" :key="ele">
                <div class="s-honor-list">
                  <div
                    class="s-honor-item"
                    v-for="(item, index) in honorList[ele-1]"
                    :key="index"
                    @click="handleDeyails(item.id)"
                  >
                    <div class="s-honor-img">
                      <img
                        :src="diseasesInsectPestsImgURL+ (item.pathogenUrl?item.pathogenUrl.split(';')[0]:'')"
                        alt
                      />
                      <p class="diseaseName">{{ item.diseaseName }}</p>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="emptyDiv" v-show="honorList[0].length == 0">
              <el-empty description="相关病例暂无数据"></el-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import { details, pageList } from "../utils/api/diseasesInsectPests";
export default {
  components: { topNav },
  data() {
    return {
      dataId: "",
      dataType: "",
      positionType: "",
      detialData: {},
      honorNum: 1,
      diseasesDataList: [],
      honorList: []
    };
  },
  mounted() {
    this.dataId = this.$route.query.id;
    this.dataType = this.$route.query.type;
    this.positionType = this.$route.query.positionType;
    this.getDetail();
    this.pageList();
  },
  methods: {
    async getDetail() {
      let res = await details({ id: this.dataId, type: this.dataType });
      if (res.data.code === 0) {
        if (this.dataType == 0) {
          this.detialData = {
            title: res.data.data.diseaseName,
            diseaseDescribe: res.data.data.diseaseDescribe,
            preventionPlan: res.data.data.preventionPlan,
            img: res.data.data.diseaseImg.split(";")
          };
        } else {
          this.detialData = {
            title: res.data.data.pestName,
            diseaseDescribe: res.data.data.pestDescribe,
            preventionPlan: res.data.data.preventionPlan,
            img: res.data.data.pestUrl.split(";")
          };
        }
      }
    },
    async pageList() {
      let obj = {
        currentPage: 1,
        pageSize: 10,
        positionType: this.positionType,
        sort: "asc",
        type: this.dataType,
        title: ""
      };
      let res = await pageList(obj);
      if (res.data.code == 0) {
        if (this.dataType == 0) {
          this.diseasesDataList = res.data.data.records;
        } else {
          if (res.data.data.records.length > 0) {
            this.diseasesDataList = res.data.data.records.map(item => {
              return {
                pathogenUrl: item.pestUrl,
                diseaseName: item.pestName,
                id: item.id
              };
            });
          } else {
            this.diseasesDataList = [];
          }
        }
        this.$nextTick(() => {
          let idx = this.diseasesDataList.findIndex(item => {
            if (item.id == this.dataId) {
              return true;
            }
          });
          this.diseasesDataList.splice(idx, 1);
          if (this.diseasesDataList.length > 3) {
            this.honorNum = Math.ceil(this.diseasesDataList.length / 3);
            this.honorList = this.getNewArray(this.diseasesDataList, 3);
          } else {
            this.honorNum = 1;
            this.honorList[0] = this.diseasesDataList;
          }
          this.$forceUpdate();
        });
      }
    },
    getNewArray(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
    handleDeyails(id) {
      this.dataId = id;
      this.getDetail();
      this.pageList();
    },
    goRoute(url) {
      this.$router.push({ path: url,query:{dataType:this.dataType,positionType:this.positionType} });
    }
  }
};
</script>

<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/diseasesInsectPests.scss";
.middle_honor {
  height: 300px;
  .mid_content {
    height: 100%;
  }
  .s-honor-wrap {
    width: 1300px;
    // background: rgba(84, 174, 73, 0.05);
    height: 100%;
    //padding: 20px;
    padding: 0 20px 12px 20px;

    .el-carousel__container {
      height: 100%;
    }

    .el-carousel__arrow {
      display: block !important;
    }

    .el-carousel__arrow {
      font-size: 20px;
      color: #00d5fb;
      font-weight: bold;
    }

    .el-carousel__indicators {
      display: none;
    }
  }
  .mid_bottom_content::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: rgba(26, 74, 108, 0.8);
  }
  .mid_bottom_content::-webkit-scrollbar-track {
    border-radius: 6px;
    background-color: rgba(26, 74, 108, 0.2);
    // background-color: transparent;
  }
  .mid_bottom_content::-webkit-scrollbar {
    width: 5px;
    height: 1px;
  }
  .s-honor-wrap {
    width: 100%;
    // background: rgba(84, 174, 73, 0.05);
    height: 100%;
    //padding: 20px;
    padding: 0 20px 12px 20px;
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__arrow {
      display: block !important;
    }
    .el-carousel__arrow {
      font-size: 20px;
      color: #00d5fb;
      font-weight: bold;
    }
    .el-carousel__indicators {
      display: none;
    }
  }
  .s-honor-list {
    width: 1300px;
    margin: 0 auto;
    margin-top: 8px;
    display: flex;
    justify-content: flex-start;
    height: 100%;
    .s-honor-item {
      cursor: pointer;
      width: 430px;
      height: 100%;
      //background-color: #fff;
      padding: 0;
      //padding: 0 0 15px 0;
      margin-right: 10px;
      .s-honor-img {
        width: 100%;
        height: 80%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .diseaseName {
        text-align: center;
        font-size: 18px;
        color: #000;
        font-weight: 700;
        padding: 10px 0;
      }
    }
    .el-carousel__item {
      width: 90% !important;
      margin-left: 5% !important;
    }
  }
}
</style>